import axios from "axios";
import { toast } from "react-toastify";
import { store } from "@src/redux/storeConfig/store";
import { handleLogout } from "@src/redux/actions/auth";
import { versionControl } from "@helper/VersionControl";

const SESSION_EXPIRED_TOAST_ID = "session-expired";
const VERSION_MISMATCH_TOAST_ID = "version-mismatch";

let isSessionExpiryHandled = false;

function safeAxiosResponseFromError(error) {
  const res = error?.response;
  return {
    // Keep an object shape so `response.data.*` accessors do not crash.
    data: { data: null, teams: [], organizations: [], handled: true },
    status: res?.status,
    statusText: res?.statusText,
    headers: res?.headers,
    config: error?.config,
    request: error?.request,
  };
}

export const apiClient = axios.create();

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const authError = error?.response?.status === 401;
    const versionError = error?.response?.data?.flag === "VERSION_NOT_MATCHED";
console.log("API Client Interceptor - Auth Error:", authError);
console.log("API Client Interceptor - Version Error:", versionError);
    if (authError || versionError) {
      if (!isSessionExpiryHandled) {
        isSessionExpiryHandled = true;

        toast.dismiss();

        if (versionError) {
          toast.error(
            "We have added new features. After reload page, Please login again to access them.",
            { toastId: VERSION_MISMATCH_TOAST_ID }
          );
          versionControl();
        } else {
          toast.error("Session expired. Please log in again.", {
            toastId: SESSION_EXPIRED_TOAST_ID,
          });
        }

        store.dispatch(handleLogout());
      }

      // Do NOT propagate auth/version errors further.
      return Promise.resolve(safeAxiosResponseFromError(error));
    }

    return Promise.reject(error);
  }
);

export function resetSessionExpiryHandledFlag() {
  isSessionExpiryHandled = false;
}

